const routes = [
    {
        path: "/reservation/system/form",
        component: () => import("../pages/Index"),
        meta: {
        }
    },
    {
        path: "/reservation/system/form/send-email",
        component: () => import("../pages/SendEmail"),
        meta: {
        },
    },
];

export default routes;
